<ng-container *ngIf="reportAgingData.length == 0">

Loading...
</ng-container>


<ng-container  *ngIf="reportAgingData.length > 0">
<div class="container-full">
  <div class="row">

 
    <div class="col-4">
      <mat-card>
        <mat-card-header>
          <mat-card-title>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <app-invoice-aging-chart></app-invoice-aging-chart>
      </mat-card-content>
      </mat-card>
    </div>


  <div class="col-8">
    <mat-card>
      <mat-card-header>
        <mat-card-title>
          
         
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="text-center">
        <span style="font-size:18px;" class="ace-heading-text-secondary">Invoice Aging</span>
      </div>
          <table style="margin-top:30px;width:99%">
            <tr style="height:80px;">
              <th style="width: 80px;">
                
              </th>
              <th  style="width:13%;background-color:#003087;color:#6FCFEB;">
                <div class="row cell-data-font" style="text-align: center;width:100%;display:block">
                  Current
                </div>
               
                <div class="row">
                  <div class="col-4 text-center">
                    <div style="padding-left:5px;">Qty</div>
                  </div>
                  <div class="col-8 text-center">
                    Amount
                  </div>
                </div>
  
              </th>
              <th  style="width:13%;background-color:#003087;color:#6FCFEB;">
                <div class="row" style="text-align: center;width:100%;display:block">
                  1-30
                </div>
               
                <div class="row">
                  <div class="col-4 text-center">
                    <div style="padding-left:5px;">Qty</div>
                  </div>
                  <div class="col-8 text-center">
                    Amount
                  </div>
                </div>
              </th>
              <th  style="width:13%;background-color:#003087;color:#6FCFEB;">
                <div class="row" style="text-align: center;width:100%;display:block">
                  31-60
                </div>
              
                <div class="row">
                  <div class="col-4 text-center">
                    <div style="padding-left:5px;">Qty</div>
                  </div>
                  <div class="col-8 text-center">
                    Amount
                  </div>
                </div>
              </th>
              <th  style="width:13%;background-color:#003087;color:#6FCFEB;">
                <div class="row" style="text-align: center;width:100%;display:block">
                  61-90
                </div>
             
                <div class="row">
                  <div class="col-4 text-center">
                    <div style="padding-left:5px;">Qty</div>
                  </div>
                  <div class="col-8 text-center">
                    Amount
                  </div>
                </div>
              </th>
              <th  style="width:13%;background-color:#003087;color:#6FCFEB;">
                <div class="row" style="text-align: center;width:100%;display:block">
                  Over 90
                </div>
             
                <div class="row">
                  <div class="col-4 text-center">
                    <div style="padding-left:5px;">Qty</div>
                  </div>
                  <div class="col-8 text-center">
                    Amount
                  </div>
                </div>
              </th>
  
              <th  style="width:20%;background-color:#003087;color:#6FCFEB;">
                <div class="row" style="text-align: center;width:100%;display:block">
                  Grand Total
                </div>
             
                <div class="row">
                  <div class="col-4 text-center">
                    <div style="padding-left:5px;">Qty</div>
                  </div>
                  <div class="col-8 text-center">
                    Amount
                  </div>
                </div>
              </th>
          </tr>
  
          <tr>
            <td style="height:60px;"><span style="font-size:18px;" class="ace-heading-text-secondary">Company</span></td>
            <td  style="border-right-width: 1px;border-right-color: black;">
              <div class="row cell-data-font">
                <div class="col-4 text-center">
                  @if(this.companyAging[0] >= 0){
                    {{this.companyAging[0] | number}}
                  }
                  @else {
                    <span style="color:red">{{this.companyAging[0] | number}}</span>
                  }
                </div>
                <div class="col-8 text-center">
                  @if(this.companyAging[1] >= 0){
                    {{this.companyAging[1] | currency : 'USD' : 'symbol' : '1.0-0'}}
                  }
                  @else {
                    <span style="color:red">{{this.companyAging[1] | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                  }
                </div>
              </div></td>
  
            <td  style="border-right-width: 1px;border-right-color: black;">
              <div class="row cell-data-font">
                <div class="col-4 text-center">
                  @if(this.companyAging[2] >= 0){
                    {{this.companyAging[2] | number}}
                  }
                  @else {
                    <span style="color:red">{{this.companyAging[2] | number}}</span>
                  }
                </div>
                <div class="col-8 text-center">
                  @if(this.companyAging[3] >= 0){
                    {{this.companyAging[3] | currency : 'USD' : 'symbol' : '1.0-0'}}
                  }
                  @else {
                    <span style="color:red">{{this.companyAging[3] | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                  }
                </div>
              </div></td>
  
              <td  style="border-right-width: 1px;border-right-color: black;">
              <div class="row cell-data-font">
                <div class="col-4 text-center">
                  @if(this.companyAging[4] >= 0){
                    {{this.companyAging[4] | number}}
                  }
                  @else {
                    <span style="color:red">{{this.companyAging[4] | number}}</span>
                  }
                </div>
                <div class="col-8 text-center">
                  @if(this.companyAging[5] >= 0){
                    {{this.companyAging[5] | currency : 'USD' : 'symbol' : '1.0-0'}}
                  }
                  @else {
                    <span style="color:red">{{this.companyAging[5] | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                  }
                </div>
              </div></td>
  
              <td  style="border-right-width: 1px;border-right-color: black;">
              <div class="row cell-data-font">
                <div class="col-4 text-center">
                  @if(this.companyAging[6] >= 0){
                    {{this.companyAging[6] | number}}
                  }
                  @else {
                    <span style="color:red">{{this.companyAging[6] | number}}</span>
                  }
                </div>
                <div class="col-8 text-center">
                  @if(this.companyAging[7] >= 0){
                    {{this.companyAging[7] | currency : 'USD' : 'symbol' : '1.0-0'}}
                  }
                  @else {
                    <span style="color:red">{{this.companyAging[7] | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                  }
                </div>
              </div></td>
  
              <td  style="border-right-width: 1px;border-right-color: black;">
              <div class="row cell-data-font">
                <div class="col-4 text-center">
                  @if(this.companyAging[8] >= 0){
                    {{this.companyAging[8] | number}}
                  }
                  @else {
                    <span style="color:red">{{this.companyAging[8] | number}}</span>
                  }
                </div>
                <div class="col-8 text-center">
                  @if(this.companyAging[9] >= 0){
                    {{this.companyAging[9] | currency : 'USD' : 'symbol' : '1.0-0'}}
                  }
                  @else {
                    <span style="color:red">{{this.companyAging[9] | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                  }
                </div>
              </div></td>
  
              <td >
                <div class="row cell-data-font">
                <div class="col-4 text-center">
                  @if(this.companyAging[10] >= 0){
                    {{this.companyAging[10] | number}}
                  }
                  @else {
                    <span style="color:red">{{this.companyAging[10] | number}}</span>
                  }
                  </div>
                  <div class="col-8 text-center">
                    @if(this.companyAging[11] >= 0){
                      {{this.companyAging[11] | currency : 'USD' : 'symbol' : '1.0-0'}}
                    }
                    @else {
                      <span style="color:red">{{this.companyAging[11] | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                    }
                  </div>
                </div></td>
          </tr>
          <tr>
            <td>
              <span style="font-size:18px;" class="ace-heading-text-secondary">Parker</span></td>
              <td  style="border-bottom-width: 2px;border-bottom-color: black;border-bottom-style: underline;border-right-width: 1px;border-right-color: black;">
                <div class="row cell-data-font" style="font-size:11px;">
                  <div class="col-4 text-center">
                    @if(this.parkerAging[0] >= 0){
                      {{this.parkerAging[0] | number}}
                    }
                    @else {
                      <span style="color:red">{{this.parkerAging[0] | number}}</span>
                    }
                  </div>
                  <div class="col-8 text-center">
                    @if(this.parkerAging[1] >= 0){
                      {{this.parkerAging[1] | currency : 'USD' : 'symbol' : '1.0-0'}}
                    }
                    @else {
                      <span style="color:red">{{this.parkerAging[1] | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                    }
                  </div>
                </div></td>
    
              <td  style="border-bottom-width: 2px;border-bottom-color: black;border-bottom-style: underline;border-right-width: 1px;border-right-color: black;">
                <div class="row cell-data-font">
                  <div class="col-4 text-center">
                    @if(this.parkerAging[2] >= 0){
                      {{this.parkerAging[2] | number}}
                    }
                    @else {
                      <span style="color:red">{{this.parkerAging[2] | number}}</span>
                    }
                  </div>
                  <div class="col-8 text-center">
                    @if(this.parkerAging[3] >= 0){
                      {{this.parkerAging[3] | currency : 'USD' : 'symbol' : '1.0-0'}}
                    }
                    @else {
                      <span style="color:red">{{this.parkerAging[3] | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                    }
                  </div>
                </div></td>
    
              <td  style="border-bottom-width: 2px;border-bottom-color: black;border-bottom-style: underline;border-right-width: 1px;border-right-color: black;">
                <div class="row cell-data-font">
                  <div class="col-4 text-center">
                    @if(this.parkerAging[4] >= 0){
                      {{this.parkerAging[4] | number}}
                    }
                    @else {
                      <span style="color:red">{{this.parkerAging[4] | number}}</span>
                    }
                  </div>
                  <div class="col-8 text-center">
                    @if(this.parkerAging[5] >= 0){
                      {{this.parkerAging[5] | currency : 'USD' : 'symbol' : '1.0-0'}}
                    }
                    @else {
                      <span style="color:red">{{this.parkerAging[5] | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                    }
                  </div>
                </div></td>
    
              <td  style="border-bottom-width: 2px;border-bottom-color: black;border-bottom-style: underline;border-right-width: 1px;border-right-color: black;">
                <div class="row cell-data-font">
                  <div class="col-4 text-center">
                    @if(this.parkerAging[6] >= 0){
                      {{this.parkerAging[6] | number}}
                    }
                    @else {
                      <span style="color:red">{{this.parkerAging[6] | number}}</span>
                    }
                  </div>
                  <div class="col-8 text-center">
                    @if(this.parkerAging[7] >= 0){
                      {{this.parkerAging[7] | currency : 'USD' : 'symbol' : '1.0-0'}}
                    }
                    @else {
                      <span style="color:red">{{this.parkerAging[7] | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                    }
                  </div>
                </div></td>
    
              <td  style="border-bottom-width: 2px;border-bottom-color: black;border-bottom-style: underline;border-right-width: 1px;border-right-color: black;">
                <div class="row cell-data-font">
                  <div class="col-4 text-center">
                    @if(this.parkerAging[8] >= 0){
                      {{this.parkerAging[8] | number}}
                    }
                    @else {
                      <span style="color:red">{{this.parkerAging[8] | number}}</span>
                    }
                  </div>
                  <div class="col-8 text-center">
                    @if(this.parkerAging[9] >= 0){
                      {{this.parkerAging[9] | currency : 'USD' : 'symbol' : '1.0-0'}}
                    }
                    @else {
                      <span style="color:red">{{this.parkerAging[9] | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                    }
                  </div>
                </div></td>
    
                <td  style="border-bottom-width: 2px;border-bottom-color: black;border-bottom-style: underline;">
                  <div class="row cell-data-font">
                  <div class="col-4 text-center">
                    @if(this.parkerAging[10] >= 0){
                      {{this.parkerAging[10] | number}}
                    }
                    @else {
                      <span style="color:red">{{this.parkerAging[10] | number}}</span>
                    }
                    </div>
                    <div class="col-8 text-center">
                      @if(this.parkerAging[11] >= 0){
                        {{this.parkerAging[11] | currency : 'USD' : 'symbol' : '1.0-0'}}
                      }
                      @else {
                        <span style="color:red">{{this.parkerAging[11] | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                      }
                    </div>
                  </div></td>
            </tr>
          <tr>
            <td  style="height:60px;"><span style="font-size:18px;" class="ace-heading-text-secondary">Total</span></td>
            <td  style="border-bottom-width: 2px;border-bottom-color: black;border-bottom-style: double;border-right-width: 1px;border-right-color: black;">
              <div class="row cell-data-font" style="font-size:11px;">
                <div class="col-4 text-center">
                  @if(this.totalAging[0] >= 0){
                    {{this.totalAging[0] | number}}
                  }
                  @else {
                    <span style="color:red">{{this.totalAging[0] | number}}</span>
                  }
                </div>
                <div class="col-8 text-center">
                  @if(this.totalAging[1] >= 0){
                    {{this.totalAging[1] | currency : 'USD' : 'symbol' : '1.0-0'}}
                  }
                  @else {
                    <span style="color:red">{{this.totalAging[1] | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                  }
                </div>
              </div></td>
  
            <td  style="border-bottom-width: 2px;border-bottom-color: black;border-bottom-style: double;border-right-width: 1px;border-right-color: black;">
              <div class="row cell-data-font">
                <div class="col-4 text-center">
                  @if(this.totalAging[2] >= 0){
                    {{this.totalAging[2] | number}}
                  }
                  @else {
                    <span style="color:red">{{this.totalAging[2] | number}}</span>
                  }
                </div>
                <div class="col-8 text-center">
                  @if(this.totalAging[3] >= 0){
                    {{this.totalAging[3] | currency : 'USD' : 'symbol' : '1.0-0'}}
                  }
                  @else {
                    <span style="color:red">{{this.totalAging[3] | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                  }
                </div>
              </div></td>
  
            <td  style="border-bottom-width: 2px;border-bottom-color: black;border-bottom-style: double;border-right-width: 1px;border-right-color: black;">
              <div class="row cell-data-font">
                <div class="col-4 text-center">
                  @if(this.totalAging[4] >= 0){
                    {{this.totalAging[4] | number}}
                  }
                  @else {
                    <span style="color:red">{{this.totalAging[4] | number}}</span>
                  }
                </div>
                <div class="col-8 text-center">
                  @if(this.totalAging[5] >= 0){
                    {{this.totalAging[5] | currency : 'USD' : 'symbol' : '1.0-0'}}
                  }
                  @else {
                    <span style="color:red">{{this.totalAging[5] | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                  }
                </div>
              </div></td>
  
            <td  style="border-bottom-width: 2px;border-bottom-color: black;border-bottom-style: double;border-right-width: 1px;border-right-color: black;">
              <div class="row cell-data-font">
                <div class="col-4 text-center">
                  @if(this.totalAging[6] >= 0){
                    {{this.totalAging[6] | number}}
                  }
                  @else {
                    <span style="color:red">{{this.totalAging[6] | number}}</span>
                  }
                </div>
                <div class="col-8 text-center">
                  @if(this.totalAging[7] >= 0){
                    {{this.totalAging[7] | currency : 'USD' : 'symbol' : '1.0-0'}}
                  }
                  @else {
                    <span style="color:red">{{this.totalAging[7] | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                  }
                </div>
              </div></td>
  
            <td  style="border-bottom-width: 2px;border-bottom-color: black;border-bottom-style: double;border-right-width: 1px;border-right-color: black;">
              <div class="row cell-data-font">
                <div class="col-4 text-center">
                  @if(this.totalAging[8] >= 0){
                    {{this.totalAging[8] | number}}
                  }
                  @else {
                    <span style="color:red">{{this.totalAging[8] | number}}</span>
                  }
                </div>
                <div class="col-8 text-center">
                  @if(this.totalAging[9] >= 0){
                    {{this.totalAging[9] | currency : 'USD' : 'symbol' : '1.0-0'}}
                  }
                  @else {
                    <span style="color:red">{{this.totalAging[9] | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                  }
                </div>
              </div></td>
  
              <td  style="border-bottom-width: 2px;border-bottom-color: black;border-bottom-style: double;">
                <div class="row cell-data-font">
                <div class="col-4 text-center">
                  @if(this.totalAging[10] >= 0){
                    {{this.totalAging[10] | number}}
                  }
                  @else {
                    <span style="color:red">{{this.totalAging[10] | number}}</span>
                  }
                  </div>
                  <div class="col-8 text-center">
                    @if(this.totalAging[11] >= 0){
                      {{this.totalAging[11] | currency : 'USD' : 'symbol' : '1.0-0'}}
                    }
                    @else {
                      <span style="color:red">{{this.totalAging[11] | currency : 'USD' : 'symbol' : '1.0-0'}}</span>
                    }
                  </div>
                </div></td>
          </tr>
          </table>
  
  
          
      </mat-card-content>
    </mat-card>
  </div>
 
</div>
</div>


</ng-container>